export const ACTIVITIES_GET = 'ACTIVITIES_GET';
export const ACTIVITY_ADD = 'ACTIVITY_ADD';
export const ACTIVITY_GET = 'ACTIVITY_GET';
export const ACTIVITY_EDIT = 'ACTIVITY_EDIT';
export const ACTIVITY_UPLOADFILE = 'ACTIVITY_UPLOADFILE';
export const ACTIVITY_DELETE = 'ACTIVITY_DELETE';
export const ACTIVITY_RESET_SEARCH = 'ACTIVITY_RESET_SEARCH';
